(() => {
  class ColorTitleSection {
    constructor(section) {
      this.section = section;
      this.textEl = section.querySelector("[data-color-title-text]");
      this.lettersContainer = section.querySelector(
        "[data-color-title-letters]",
      );
      this.fillableLetters = [];
      this.filledCount = 0;
      this.raf = null;
      this.prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    init() {
      if (!this.textEl || !this.lettersContainer) return;
      if (this.section.dataset.colorTitleInitialized === "true") return;

      this.section.dataset.colorTitleInitialized = "true";
      this.buildLetters();

      if (this.prefersReducedMotion) {
        this.setAllFilled();
        return;
      }

      this.update();
      window.addEventListener("scroll", this.onScroll, { passive: true });
      window.addEventListener("resize", this.onResize);
    }

    splitHighlight(text, word) {
      if (!word) return [{ text, highlight: false }];

      const index = text.toLocaleLowerCase("tr-TR").indexOf(word.toLocaleLowerCase("tr-TR"));
      if (index === -1) return [{ text, highlight: false }];

      const segments = [];
      if (index > 0) {
        segments.push({ text: text.slice(0, index), highlight: false });
      }
      segments.push({ text: text.slice(index, index + word.length), highlight: true });
      if (index + word.length < text.length) {
        segments.push({
          text: text.slice(index + word.length),
          highlight: false,
        });
      }
      return segments;
    }

    buildLetters() {
      const text = this.section.dataset.text || "";
      const highlightWord = this.section.dataset.highlightWord || "";
      const highlightItalic =
        this.section.dataset.highlightItalic === "true";

      this.lettersContainer.innerHTML = "";
      this.fillableLetters = [];

      const segments = this.splitHighlight(text, highlightWord);
      const fragment = document.createDocumentFragment();

      segments.forEach(({ text: segmentText, highlight }) => {
        const segmentWrapper = document.createElement("span");
        segmentWrapper.className = "color-title__segment";
        if (highlight) {
          segmentWrapper.classList.add("color-title__segment--highlight");
          if (highlightItalic) {
            segmentWrapper.classList.add("color-title__segment--italic");
          }
        }
        this.appendText(segmentWrapper, segmentText, highlight);
        fragment.appendChild(segmentWrapper);
      });

      this.lettersContainer.appendChild(fragment);
    }

    appendText(container, text, isHighlight) {
      const words = text.split(/(\s+|\n)/);

      words.forEach((word) => {
        if (word === "\n") {
          container.appendChild(document.createElement("br"));
          return;
        }

        const wordSpan = document.createElement("span");
        wordSpan.className = "color-title__word";

        Array.from(word).forEach((char) => {
          const span = document.createElement("span");
          span.className = "color-title__letter";
          if (isHighlight) {
            span.classList.add("color-title__letter--highlight");
          }
          span.textContent = char;

          if (char.trim() === "") {
            span.classList.add("color-title__space");
          } else {
            this.fillableLetters.push(span);
          }

          wordSpan.appendChild(span);
        });

        container.appendChild(wordSpan);
      });
    }

    setAllFilled() {
      this.fillableLetters.forEach((letter) =>
        letter.classList.add("is-filled"),
      );
      this.filledCount = this.fillableLetters.length;
    }

    onScroll() {
      if (this.raf) return;
      this.raf = window.requestAnimationFrame(() => {
        this.raf = null;
        this.update();
      });
    }

    onResize() {
      this.onScroll();
    }

    update() {
      const total = this.fillableLetters.length;
      if (total === 0) return;

      const rect = this.section.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const start = viewportHeight * 0.85;
      const end = viewportHeight * 0.15;
      const progress = this.clamp((start - rect.top) / (start - end), 0, 1);
      const nextCount = Math.round(progress * total);

      if (nextCount === this.filledCount) return;

      if (nextCount > this.filledCount) {
        for (let i = this.filledCount; i < nextCount; i += 1) {
          this.fillableLetters[i]?.classList.add("is-filled");
        }
      } else {
        for (let i = this.filledCount - 1; i >= nextCount; i -= 1) {
          this.fillableLetters[i]?.classList.remove("is-filled");
        }
      }

      this.filledCount = nextCount;
    }

    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }
  }

  const initColorTitleSections = (root = document) => {
    root.querySelectorAll("[data-color-title]").forEach((section) => {
      section.dataset.colorTitleInitialized = "false";
      const instance = new ColorTitleSection(section);
      instance.init();
    });
  };

  document.addEventListener("DOMContentLoaded", () => initColorTitleSections());

  document.addEventListener("shopify:section:load", (event) => {
    const sectionId = event.detail.sectionId;
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (section) initColorTitleSections(section);
  });
})();
